

export class EstadisticaPersonalizadaQuery{
    SorteoId: number = 0;
    Numero: string = "";
    PrimeraCifra: string = "";
    SegundaCifra: string = "";
    TerceraCifra: string = "";
    CuartaCifra: string = "";
    QuintaCifra: string = "";

    numeroFormat(){
        let result = "";

        result += ((this.PrimeraCifra !== "") ? this.PrimeraCifra : "X")+ " ";
        result += ((this.SegundaCifra !== "") ? this.SegundaCifra : "X")+ " ";
        result += ((this.TerceraCifra !== "") ? this.TerceraCifra : "X")+ " ";
        result += ((this.CuartaCifra !== "") ? this.CuartaCifra : "X")+ " ";
        result += ((this.QuintaCifra !== "") ? this.QuintaCifra : "X")+ " ";

        return result
    }
}